/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseActivityEvent } from './CaseActivityEvent';
import {
    CaseActivityEventFromJSON,
    CaseActivityEventFromJSONTyped,
    CaseActivityEventToJSON,
    CaseActivityEventToJSONTyped,
} from './CaseActivityEvent';

/**
 * 
 * @export
 * @interface CaseActivityPage
 */
export interface CaseActivityPage {
    /**
     * 
     */
    events: Array<CaseActivityEvent>;
    /**
     * 
     */
    next_cursor: string | null;
}

/**
 * Check if a given object implements the CaseActivityPage interface.
 */
export function instanceOfCaseActivityPage(value: object): value is CaseActivityPage {
    if (!('events' in value) || value['events'] === undefined) return false;
    if (!('next_cursor' in value) || value['next_cursor'] === undefined) return false;
    return true;
}

export function CaseActivityPageFromJSON(json: any): CaseActivityPage {
    return CaseActivityPageFromJSONTyped(json, false);
}

export function CaseActivityPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseActivityPage {
    if (json == null) {
        return json;
    }
    return {
        
        'events': ((json['events'] as Array<any>).map(CaseActivityEventFromJSON)),
        'next_cursor': json['next_cursor'],
    };
}

export function CaseActivityPageToJSON(json: any): CaseActivityPage {
    return CaseActivityPageToJSONTyped(json, false);
}

export function CaseActivityPageToJSONTyped(value?: CaseActivityPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'events': ((value['events'] as Array<any>).map(CaseActivityEventToJSON)),
        'next_cursor': value['next_cursor'],
    };
}

